import { jsx as w } from "react/jsx-runtime";
import { useTranslation as q, useBreakpoint as F, Breakpoints as S, useToast as K, SocialPlateforms as d, Notification as Y, Theme as B } from "@nextgen-web-framework/all";
import { ConfigService as D, ConsoleLogger as u } from "@nextgen-web-framework/core";
import { getSocialLinksConfig as N, createSharecode as X, publishShareEvent as H, getSharePath as J } from "../../utils/sharebar/sharebarHelpers.js";
import Q from "../SocialLink/SocialLink.js";
import '../../assets/SocialLinks.css';const Z = "#ffffff", M = "#396e75", P = "#e5fdff", T = "#546223", x = "#f0fae5", oo = "#a65523", to = "#fff1e8", ao = "#7f3e3e", eo = "#ffe2e2", no = "#62625a", ro = "#f8f8e7", co = "#38539a", lo = "#707070", io = "#c8f8d1", so = "#87c9c8", mo = "#5291b1", uo = "rgba(82, 145, 177, 0.1019607843)", po = "#445685", fo = "#181d61", Co = "rgba(24, 29, 97, 0.1019607843)", go = "#5969d6", ho = "#ea999d", wo = "#b6577e", bo = "rgba(182, 87, 126, 0.1019607843)", ko = "#7e3e80", zo = "#1e247f", Vo = "rgba(30, 36, 127, 0.1019607843)", yo = "#da7600", So = "#107f47", Bo = "#d91734", Ro = "_html_1j0q2_38", $o = {
  amwayWhite: Z,
  darkBlue: M,
  lightBlue: P,
  darkGreen: T,
  lightGreen: x,
  darkOrange: oo,
  lightOrange: to,
  darkRed: ao,
  lightRed: eo,
  darkYellow: no,
  lightYellow: ro,
  darkPurple: co,
  darkGrayOnWhite: lo,
  dataVizColor1: io,
  dataVizColor2: so,
  dataVizColor3: mo,
  dataVizColor3Background: uo,
  dataVizColor4: po,
  dataVizColor5: fo,
  dataVizColor5Background: Co,
  dataVizColor6: go,
  dataVizColor7: ho,
  dataVizColor8: wo,
  dataVizColor8Background: bo,
  dataVizColor9: ko,
  dataVizColor10: zo,
  dataVizColor10Background: Vo,
  dataVizAlertOrange: yo,
  dataVizSuccessGreen: So,
  dataVizWarningRed: Bo,
  "no-visible": "_no-visible_1j0q2_34",
  html: Ro,
  "sharing-channel-wrapper": "_sharing-channel-wrapper_1j0q2_72"
}, Io = ({
  socialIconsVisibility: m,
  existingSharecode: b,
  linkProps: c,
  shareTextMessage: e,
  regType: R,
  socialLinkHandler: p
}) => {
  const i = q(), k = F(), $ = k === S.XS || k === S.SM, { addToast: U, deleteToast: _ } = K(), v = D.getConfigs(), z = "link_copied_toast_id", O = i("web.link.copied.success.message"), E = i("web.link.copied.failure.message"), I = i("web.line.message"), L = i("web.whatsapp.message"), j = i("web.email.subject"), A = i("web.email.body"), s = (t) => {
    U({
      id: z,
      timeout: 1e3,
      content: /* @__PURE__ */ w(
        Y,
        {
          theme: t ? B.SUCCESS : B.ERROR,
          onCloseClick: () => _(z),
          message: t ? O : E
        }
      )
    });
  }, f = (t) => {
    if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
      const o = document.createElement("input");
      o.value = t, document.body.appendChild(o), o.select();
      try {
        document.execCommand("copy"), s(!0);
      } catch (n) {
        u.error("Document Failed to copy: ", n, t), s(!1);
      } finally {
        document.body.removeChild(o);
      }
    } else
      u.error("Clipboard document copy not supported"), s(!1);
  }, C = async (t) => {
    var a;
    let o = "", n = "";
    try {
      return b ? o = `${b}?utm_source=${t}` : o = (a = await X({ linkProps: c, sharingChannel: t, regType: R })) == null ? void 0 : a.sharecode, H(c, t), n = J(o, v.NEXT_SHARELINK_DOMAIN, m.sharelinkPath), n;
    } catch (r) {
      u.error("Error fetching sharecode or generating share link URL", r);
    }
    return "";
  }, V = (t) => s(!!t), G = (t) => {
    var n;
    let o = "";
    if ((n = navigator == null ? void 0 : navigator.clipboard) != null && n.write)
      try {
        const a = new ClipboardItem({
          "text/plain": C(t).then((r) => (o = r, V(r), new Blob([r], { type: "text/plain" })))
        });
        navigator.clipboard.write([a]);
      } catch {
        f(o);
      }
    else
      C(t).then((a) => {
        var r;
        o = a, V(a), (r = navigator == null ? void 0 : navigator.clipboard) != null && r.writeText ? navigator.clipboard.writeText(o) : f(o);
      }).catch((a) => {
        u.error("Failed to copy: ", a), f(o);
      });
  }, W = async (t) => {
    var a, r, y;
    if (p != null && p())
      return;
    let o = "";
    if (t !== d.LINK && (o = await C(t), !o)) {
      s(!1);
      return;
    }
    const n = ((a = e == null ? void 0 : e.platformSpecific) == null ? void 0 : a[t]) || (e == null ? void 0 : e.message) || "";
    switch (t) {
      case d.MORE: {
        const l = {
          title: c == null ? void 0 : c.title,
          text: c == null ? void 0 : c.title,
          url: o
        };
        navigator.share(l);
        break;
      }
      case d.LINE: {
        const l = `${m.lineUrl}${encodeURIComponent(
          `${o}`
        )}&text=${encodeURIComponent(n || I)}`;
        window == null || window.open(l);
        break;
      }
      case d.WHATSAPP: {
        const g = `${n || L} ${o}`, h = `${m.whatsappUrl}${encodeURIComponent(g)}`;
        window == null || window.open(h);
        break;
      }
      case d.EMAIL: {
        const l = ((r = e == null ? void 0 : e.email) == null ? void 0 : r.subject) || j, g = `${((y = e == null ? void 0 : e.email) == null ? void 0 : y.body) || A} ${o}`, h = `mailto:?subject=${l}&body=${encodeURIComponent(g)}`;
        window.location.href = h;
        break;
      }
      case d.FACEBOOK: {
        const l = `${m.fbUrl}${encodeURIComponent(`${o}`)}`;
        window.open(l);
        break;
      }
      case d.LINK: {
        G(t);
        break;
      }
    }
  };
  return /* @__PURE__ */ w("div", { className: $o["sharing-channel-wrapper"], "data-testid": "social-links-test-id", "data-pod-name": "commerce", children: N(m, $).map(
    ({ type: t, enabled: o, titleKey: n }) => o && /* @__PURE__ */ w(Q, { iconName: t, iconTitle: i(n), iconClickHandler: W }, t)
  ) });
};
export {
  Io as default
};
//# sourceMappingURL=SocialLinks.js.map
